import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
@Component({
    selector: 'app-third-image',
    templateUrl: './third-image.component.html',
    styleUrls: ['./third-image.component.scss'],
    standalone: false
})
export class ThirdImageComponent {
  node2: Observable<any> = this.component.data$;
  
  constructor(public component: CmsComponentData<CmsBannerComponent>,private cmsService:CmsService, protected config: OccConfig,private route:ActivatedRoute) {
}
getVideo(video: any): string {
  return this.config.backend?.occ?.baseUrl + video.url;
}
ngAfterViewInit(){
  this.route.fragment.subscribe(fragment => {
    if(fragment == 'video'){
      setTimeout(()=>{
        const ele = document.querySelector('.adjuvant-video');
        if(ele){
          ele.scrollIntoView({behavior:'smooth',block:'start'});
        }
      },500)
      
    }
  })
}
}
